import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { useAuth } from "react-oidc-context";
import { Link } from 'react-router-dom';
import { LayoutContext } from 'App/Layout/store'
import axios from 'axios'
import _ from 'underscore';
import moment from 'moment';
import { Label, ResponsiveContainer, Line, ComposedChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';
import DetallesDTE from 'App/components/DetallesDTE';

const styles = theme => ({
  fab: {
    position: 'relative',
    left: "85%"
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    width: '100%',
  },
  image: {
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 4}px ${theme.spacing.unit + 6}px`,
  },

});

function Home(props) {
  const { classes } = props;
  const auth = useAuth();
  const layoutContext = useContext(LayoutContext);
  const [dte, setDte] = useState(null);

  const images = [
    {
      link: '/emitidos',
      title: 'Emitidos',
      width: '33%',
    },
    {
      link: '/recibidos',
      title: 'Recibidos',
      width: '33%',
    },
    {
      title: 'Crear Nuevo',
      width: '33%',
    },
  ];

  useEffect(() => {
    if (auth.isAuthenticated && (((props || {}).match || {}).params || {}).folio) {
      var rut = props.match.params.emisor.match(/^(\d+)/g)[0];
      axios.get("/api/dte/id/" + rut + "/" + props.match.params.tipo + "/" + props.match.params.folio)
        .then(doc => setDte(doc)).catch(e => console.error(e))
    }
  }, [])

  useEffect(() => {
    if (auth.isAuthenticated) {
      axios.get("/api/Estadisticas").then(estadisticas => {
        estadisticas = estadisticas.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)).map(e => {
          e.fecha = moment(e.fecha).format("MMM YYYY")
          return e;
        });
        layoutContext.dispatch({ type: "setEstadisticasEmpresa", estadisticas: estadisticas.filter(o => o.total > 0) });
      });
    }
  }, [auth.isAuthenticated]);

  const COLORS = ["#01B8AA", "#374649", "#FD625E", "#F2C80F", "#5F6B6D", "#8AD4EB", "#FE9666", "#A66999"];

  var esAdmin = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre.startsWith("Administracion") && p.BLectura+p.BEscritura)

  return (
    <Grid container spacing={24}>
      {auth.isAuthenticated ?
        <Grid item xs={12}>
          <Grid item sm={12}>
            <Typography variant="h4" gutterBottom>Te damos la bienvenida {auth.isAuthenticated ?
              auth.user.profile.name : ""}</Typography>
          </Grid>
          <Paper className={classes.paper}>
            <div className={classes.root}>
              {images.map((image, i) =>
                image.title == "Emitidos" && layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BLectura)
                || image.title == "Recibidos" && layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Recibidos" && p.BLectura)
                || image.title == "Crear Nuevo" && layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BEscritura) ? (
                  <ButtonBase
                    onClick={() => { if (!image.link) { layoutContext.dispatch({ type: "toggleNuevaVenta" }) } }}
                    focusRipple
                    key={image.title}
                    className={classes.image}
                    focusVisibleClassName={classes.focusVisible}
                    style={{
                      width: image.width,
                    }}
                  >
                    <Link to={image.link || "#"}>
                      <span
                        className={classes.imageSrc}
                        style={{
                          backgroundImage: `url(${image.url})`,
                        }}
                      />
                      <span className={classes.imageBackdrop} />
                      <span className={classes.imageButton}>
                        <Typography
                          component="span"
                          variant="subtitle1"
                          color="inherit"
                          className={classes.imageTitle}
                        >
                          {image.title}
                          <span className={classes.imageMarked} />
                        </Typography>
                      </span>
                    </Link>
                  </ButtonBase>
                ):null)}
            </div>
            <DetallesDTE abrir={dte} DTE={[dte]} cerrar={() => { setDte(null) }} />
          </Paper>
          {esAdmin && <div>
            <br />
            <br />
            <br />
            <Typography variant="h5" gutterBottom>Estadisticas documentos emitidos</Typography>
            <br />
            <Paper className={classes.paper}>
              <Typography>
                <ResponsiveContainer width={"100%"} height={350}>
                  <ComposedChart width={730} height={350} data={Object.entries(_.groupBy(layoutContext.state.estadisticasEmpresa, "fecha")).map(g => {
                    var ret = { fecha: g[0] }
                    g[1].map(d => {
                      var nombre = (_.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(d.tipo) }) || {}).Nombre;
                      ret["Monto " + nombre] = d.total;
                      ret["Cantidad " + nombre] = d.cantidad;
                    })
                    return ret;
                  })}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis dataKey="fecha" />
                    <YAxis yAxisId="left" tickFormatter={tick => {
                      return "$ " + ((tick / 1000000).toLocaleString()) + " M";
                    }}>
                      <Label
                        value='Monto CLP'
                        position='insideLeft'
                        angle={-90}
                        style={{ fill: "#999" }}
                      />
                    </YAxis>
                    <YAxis yAxisId="right" orientation="right">
                      <Label
                        value='Cantidad'
                        position='insideRight'
                        angle={90}
                        style={{ fill: "#999" }}
                      />
                    </YAxis>
                    <Tooltip />
                    {/* <Legend/> */}
                    {Object.entries(_.groupBy(layoutContext.state.estadisticasEmpresa, "tipo")).map((g, i) => {
                      return (
                        <Bar yAxisId="left" dataKey={"Monto " + (_.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(g[0]) }) || {}).Nombre} fill={COLORS[i % COLORS.length]} stackId="total" />
                      )
                    })}
                    {Object.entries(_.groupBy(layoutContext.state.estadisticasEmpresa, "tipo")).map((g, i) => {
                      return (
                        <Line yAxisId="right" dataKey={"Cantidad " + (_.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(g[0]) }) || {}).Nombre} stroke={COLORS[i % COLORS.length]} />
                      )
                    })}
                  </ComposedChart>
                </ResponsiveContainer>
              </Typography>
            </Paper>
          </div>}
          <br />
          <br />
          <Typography variant="h5" gutterBottom>Video Tutoriales</Typography>
          <br />
          <Paper>
            <iframe width="560" style={{ display: "block", margin: "0 auto" }} height="315" src="https://www.youtube.com/embed/videoseries?list=UUI3zvtm1QXpynO-Dh-Qev-w" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </Paper>
        </Grid>
        : <iframe src="https://asyntec.wixsite.com/website-1/facturacion-electronica" style={{ height: "calc(100vh - 64px)", width: "calc(100% + 24px)", margin: "-12px", overflow: "hidden", border: "0" }} />}
    </Grid>
  )
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Home);